import { render } from "./prc-button.vue?vue&type=template&id=50b8c634&scoped=true&ts=true"
import script from "./prc-button.vue?vue&type=script&lang=ts"
export * from "./prc-button.vue?vue&type=script&lang=ts"

import "./prc-button.vue?vue&type=style&index=0&id=50b8c634&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50b8c634"]])

export default __exports__